import React from 'react';
import styles from './styles';
import PropTypes from 'prop-types';

const ContactWithButton = ({ block }) => {
  if (!block) return '';
  const { primary } = block;
  const header = primary?.header;
  const description = primary?.description;

  const openChat = () => {
    window.FrontChat('show');
  };

  return (
    <>
      <div className='main-container'>
        <h3 className='main-header'>AFTERSHOCK SUPPORT</h3>
        <div className='header-container'>
          <h3 className='header'>{header}</h3>
          <p className='description'>{description}</p>
        </div>

        <div className='btn-container'>
          <buton className='btn whatsapp' onClick={() => window.location.href="whatsapp://send?text=Hello!&phone=+6582410028"}>
            <img draggable="false"  src={'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/whatsapp.png?v=1714058143'} alt="whatsapp-icon" className='btn-icon'/>
            Whatsapp
          </buton>
          <buton className='btn livechat' onClick={openChat}>
            <img draggable="false"  src={'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/livechat.png?v=1714058251'} alt="whatsapp-icon" className='btn-icon'/>
            Live Chat
          </buton>
        </div>

        <div className='btn-container-mobile'>
          <div>
            <buton className='btn-mobile whatsapp' onClick={() => window.location.href="whatsapp://send?text=Hello!&phone=+6582410028"}>
              <img draggable="false"  src={'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/whatsapp.png?v=1714058143'} alt="whatsapp-icon" className='btn-icon-mobile'/>
            </buton>
            <span className='btn-mobile-label'>Whatsapp</span>
          </div>

          <div>
            <buton className='btn-mobile livechat' onClick={openChat}>
              <img draggable="false"  src={'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/livechat.png?v=1714058251'} alt="whatsapp-icon" className='btn-icon-mobile'/>
            </buton>
            <span className='btn-mobile-label'>Live Chat</span>
          </div>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
ContactWithButton.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      header: PropTypes.string,
      imageUrl: PropTypes.object,
    }),
  }),
};

ContactWithButton.defaultProps = {
  block: null,
};

export default ContactWithButton;